import { useContext } from 'react';
import { RootStoreContext } from '@uplift/contexts';

export function useStore() {
  const context = useContext(RootStoreContext);

  if (!context) {
    throw new Error('useStore must be used within a StoreProvider.');
  }

  return context;
}
